import React from "react";
import styled, { keyframes } from "styled-components";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { DialogButton, TextDialogButton } from "js/Components/Button";
import { defaultText, largeTitle } from "js/textStyles";
import { themeColors } from "js/react/sharedStyles";
import { getStaticUrl } from "js/config";
import { Gap10, Gap30 } from "js/react/components/Gap";

const fadeInScale = keyframes`
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
`;

const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
        padding: 40px 50px;
        max-width: 600px;
        user-select: none;
        gap: 30px;
    }
`;

const StyledDialogTitle = styled.div`
gap: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: #333333;
    font-size: 20px;
    font-family: Source Sans Pro;
    font-weight: 600;
    line-height: 24px;
    word-wrap: break-word;
`;

const StyledDialogLogo = styled.img`
    width: 50px;
    height: 50px;
`;

const StyledDialogContent = styled.div`
    color: #666666;
    font-size: 14px;
    font-family: Source Sans Pro;
    font-weight: 400;
    line-height: 17.50px;
    word-wrap: break-word;
    text-align: center;
`;

const StyledDialogActions = styled(DialogActions)`
    &.MuiDialogActions-root {
        padding: 0px;
        margin: 0px;
    }
`;

const StyledTextDialogButton = styled(TextDialogButton)`
    color: #666666;
`;

const StyledDialogButton = styled(DialogButton)`
      background-color: #FF4500;
`;

const StyledDialogContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`;

export interface LeaveWorkspaceDialogProps {
    closeDialog: (accepted: boolean) => void;
    title: string;
    message: string;
    leaveButtonText: string;
}

class LeaveWorkspaceDialog extends React.Component<LeaveWorkspaceDialogProps> {
    constructor(props: LeaveWorkspaceDialogProps) {
        super(props);
    }

    handleCancel = () => {
        const { closeDialog } = this.props;
        closeDialog(false);
    }

    handleConfirm = () => {
        const { closeDialog } = this.props;
        closeDialog(true);
    }

    render() {
        const { title, message, leaveButtonText } = this.props;

        return (
            <StyledDialog maxWidth="lg" open={true} onClose={this.handleCancel}>
                <StyledDialogContentContainer>
                    <StyledDialogTitle>
                        <StyledDialogLogo src={getStaticUrl("/images/beautiful-leave-workspace.svg")} alt="logo" />
                        <Gap10 />
                        {title}
                    </StyledDialogTitle>
                    <StyledDialogContent>{message}</StyledDialogContent>
                </StyledDialogContentContainer>
                <StyledDialogActions>
                    <StyledTextDialogButton onClick={this.handleCancel}>Cancel</StyledTextDialogButton>
                    <StyledDialogButton onClick={this.handleConfirm}>{leaveButtonText}</StyledDialogButton>
                </StyledDialogActions>
            </StyledDialog>
        );
    }
}

export default LeaveWorkspaceDialog;
